import { memo, useMemo } from 'react'

import { Alert, Box, Paper } from '@mui/material'
import { ContentAdConfigPod, SmepEvent } from '@nativewaves/nw-cloud-sdk/smep'
import { useTranslation } from 'react-i18next'
import SimpleBar from 'simplebar-react'

import { LoadingIndicator } from '@shared/layouts'
import { AdItem, AdsNotShown, formatScheduleData } from 'domains/Workspaces/Events/Event/Watch/AdPods'

type AdPodsProps = {
  event: SmepEvent
  ads?: ContentAdConfigPod[]
  isLoading: boolean
}

const AdPodsRaw = ({ event, ads, isLoading }: AdPodsProps) => {
  const { t } = useTranslation(['common', 'domain'])

  const { blocks, beforeEventBlocks, afterEventBlocks } = useMemo(() => formatScheduleData(event, ads), [ads, event])

  if (isLoading) {
    return <LoadingIndicator />
  }

  if (!event.config?.adConfig?.enabled) {
    return (
      <Alert sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} severity="info">
        {t('domain:Workspace.Event.adsDisabled')}
      </Alert>
    )
  }

  return (
    <Paper sx={{ flex: 1, overflow: 'hidden' }}>
      <SimpleBar style={{ maxHeight: '100%' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, p: 1 }}>
          {beforeEventBlocks.length ? <AdsNotShown type="before" number={beforeEventBlocks.length} /> : null}
          {blocks.map((item, i) => (
            <AdItem key={i} {...item} />
          ))}
          {afterEventBlocks.length ? <AdsNotShown type="after" number={afterEventBlocks.length} /> : null}
        </Box>
      </SimpleBar>
    </Paper>
  )
}

export const AdPods = memo(AdPodsRaw)
